import { DefaultRoute } from '../router/routes'

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
    if (!value) return value
    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

export const getHomeRouteForLoggedInUser = userRole => {
    if (userRole === 'admin') return DefaultRoute
    if (userRole === 'client') return '/access-control'
    return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
    ...theme,
    colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
    }
})

// ** Returns paginated array
export const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)

// ** Returns sorted array
export const sortCompare = key => (a, b) => {
    const fieldA = a[key]
    const fieldB = b[key]

    let comparison = 0
    if (fieldA > fieldB) {
        comparison = 1
    } else if (fieldA < fieldB) {
        comparison = -1
    }
    return comparison
}

// ** Returns number range
export const getRandomInt = (min, max) => {
    if (min > max) {
        const temp = max
        /* eslint-disable no-param-reassign */
        max = min
        min = temp
        /* eslint-enable */
    }

    if (min <= 0) {
        return Math.floor(Math.random() * (max + Math.abs(min) + 1)) + min
    }
    return Math.floor(Math.random() * max) + min
}

// ** Returns pagination page x of y values
export const calcPageXofY = (rowCount, rowsPerPage, currentPage) => {
    let startPageRow, adjustedCurrentPage 

    // Calculate total pages
    const pageCount = Math.ceil(rowCount / rowsPerPage)

    // Check if current page exceeds total pages
    if (currentPage > pageCount) {
        startPageRow = 1
        adjustedCurrentPage = 1
    } else {
        startPageRow = ((currentPage - 1) * rowsPerPage) + 1
        adjustedCurrentPage = currentPage
    }
    // Calculate the last item for the current page
    const endPageRow = Math.min(currentPage * rowsPerPage, rowCount) 

    return { pageCount, startPageRow, endPageRow, adjustedCurrentPage }
}

// ** Typicdally used by dataTable sorting
